import React from 'react';

import './style.scss';
import { Link } from "react-router-dom";

export const WhatIsIt = () => {
    return (
        <div className = 'wt wt-what-is-it'>
            <Link className = 'wt__container wt-what-is-it__container' to = '/about'>
                <h4 className = 'wt__title wt-what-is-it__title'>Що це?</h4>
                <p className = 'wt__dc wt-what-is-it__desc'>
                    «Мені здається» – це анонімний онлайн-щоденник.
                </p>
                <p className = 'wt__dc wt-what-is-it__desc-custom'>
                    Мені здається, я втрачаю себе.<br />
                    Мені здається, він до мене жорстокий.<br />
                    Мені здається, мною маніпулюють.<br />
                    Мені здається, мене використовують.<br />
                    {/*Мені здається, наші стосунки не в нормі.<br />*/}
                </p>
            </Link>
        </div>
    );

};
